import api from "@/config/axios";

const basePath = "/historial-camas";

export default {
  obtenerFechas() {
    return api.get(`${basePath}/fechas`);
  },

  obtenerHistorialPorFechaYTurno(fecha, turno) {
    return api.get(`${basePath}/${fecha}/${turno}`);
  }
};